import { ServiceProvider } from '@quasarcast/vue-service'

export const loggerServiceProvider: ServiceProvider = {
  /**
   * Register any services by adding them to app
   */
  register: async ({ vueApp }) => {
    vueApp.config.globalProperties.$log = (...params: any[]) => {
      console.log(...params)
    }
  },
}
